/**
 * 404 Page Not Found
 */
import React from 'react';
import Link from 'next/link';
import { Nav, Row, Col } from 'react-bootstrap';
import OpenGraphTitle from '../components/OpenGraphTitle';
import OpenGraphDescription from '../components/OpenGraphDescription';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import Layout from '../components/Layout';
import Head from '../components/head';
import Section from '../components/Section';
import SwooptyBg from '../components/SwooptyBg';
import '../ui/src/scripts/routes/common';
import { FranchiseeProvider } from '../context/Franchisee';
import SVG from 'react-inlinesvg';

const iconPageNotFound = '/images/icon-404.svg';

const NotFoundPage: React.FC = () => (
  <FranchiseeProvider>
    <Layout>
      <Head
        title='404 Not found | Two Maids '
        slug='404'
        description={`It seems the page you are looking for doesn't exist.`}
      />
      <OpenGraphTitle title='404 Not found | Two Maids ' />

      <OpenGraphDescription>
        {/* Add Pre Open description here */}
        It seems the page you are looking for doesn't exist.
      </OpenGraphDescription>

      <SwooptyBg />
      <Section className='my-5'>
        <Row className='justify-content-center text-center'>
          <Col xs={12} lg={12} xl={10}>
            <SVG
              src={iconPageNotFound}
              title='A piece of paper'
              className='w-100 mb-4'
            />

            <h1 className='h2 text-center mb-5'>
              We&apos;re Sorry. We couldn&apos;t find that page.
            </h1>

            <p>
              Maybe one of these links will help you find what you&apos;re
              looking for.
            </p>
            <Nav className='d-block d-lg-flex justify-content-center my-5'>
              <Nav.Item>
                <Nav.Link>
                  <Link href='/locations/'>
                    <a className='btn btn-outline-primary btn-block'>
                      Find a Store <FontAwesomeIcon icon={faSearch} />
                    </a>
                  </Link>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link>
                  <Link href='/services/'>
                    <a className='btn btn-outline-primary btn-block'>
                      Cleaning Packages
                    </a>
                  </Link>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link>
                  <Link href='/book/'>
                    <a className='btn btn-outline-primary btn-block'>
                      Get a Quote
                    </a>
                  </Link>
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
        </Row>
      </Section>
    </Layout>
  </FranchiseeProvider>
);

export default NotFoundPage;
